import React, { useState } from "react";

import CalendlyWidget from "components/care_solved/CalendlyWidget";
import CareSolvedOption from "components/care_solved/CareSolvedOption";
import SegmentClient from "clients/SegmentClient";
import phoneIcon from "icons/care-coach.png";

function CareCoach() {
  const [calendlyOpen, openCalendly] = useState(false);

  const openCalendlyHandler = open => {
    SegmentClient.trackEvent({
      event: "vitality book call click",
      eventCategory: "pre-user activation",
      eventAction: "vitality book call click",
      eventLabel: "click"
    });

    openCalendly(open);
  };

  return (
    <>
      {calendlyOpen && <CalendlyWidget openCalendly={openCalendlyHandler} />}
      <CareSolvedOption
        buttonAction={() => openCalendly(true)}
        buttonLabel="Book Call"
        description="Book a call with one of our care experts to get guidance and support."
        icon={phoneIcon}
        name="CareCoach"
      />
    </>
  );
}

export default CareCoach;
